<template>
  <div class="smsApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.smsApp="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <ul>
      <li v-for="(item,i) in sms" @click="toPush(item.id,'smsdetail')">
        <img class="fmt" :src="baseUrl+item.img" />
        <div class="right">
        <h2>{{item.title}}</h2>
        <p>起步购买条数：{{item.bars}}条</p>
        <div class="price">
          <i><b>¥</b> {{item.price.split(".")[0]}}.<b>{{item.price.split(".")[1]}} /条 </b></i>
        </div>
        </div>
        <a>立即购买</a>
      </li>
    </ul>

    <div class="yhj" @click="toPush1(id,'pushOrder')">我的订单</div>
  </div>
  
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        userData:[],
        sms:[],
        id:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });

      var id = this.$route.query.id;
      this.id = id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/sms?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }

    },
    mounted() {
      this.beforeMount();
      this.getSms();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getSms:function(){
        var that = this; 
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/message/index'
        }).then(function(response){
          var res = response.data.data;
          that.sms = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      toPush:function(index,url){
        var id = this.$route.query.id;
        this.$router.push({
          path:url,
          query:{
            id:index,
            p_id:id
          }
        })
      },

      toPush1:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },


      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .smsApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .smsApp ul{
    width:92%;
    display: block;
    margin: 0 auto;
  }

  .smsApp ul li{
    background:#fff;
    border-radius:4px;
    width:100%;
    padding:15px 0;
    position:relative;
    margin-bottom:15px;
  }
  .smsApp ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .smsApp ul li .fmt{
    float:left;
    width:15%;
    border-radius:6px;
    margin:3% 2% 0 5%;
  }
  .smsApp ul li .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .smsApp ul li h2{
    font-size:15px;
  }
  .smsApp ul li p{
    font-size:13px;
    color:#666;
    padding-top:10px;
  }
  .smsApp ul li .price{
    padding-top:10px
  }

  .smsApp ul li .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .smsApp ul li .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .smsApp ul li .price b{
    font-size:12px;
  }
  .smsApp ul li a{
    position:absolute;
    right:10px;
    bottom:0%;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }

  .smsApp .yhj{
    position: fixed;
    width:84%;
    height:45px;
    line-height:45px;
    text-align:center;
    color:#fff;
    font-size:15px;
    background: #FF751A;
    bottom:30px;
    left:8%;
    border-radius: 45px;
  }
</style>